import { createFileRoute } from '@tanstack/react-router';

import { sideline } from '@/api/sideline';
import { SidelineReviewPage } from '@/components/sideline/SidelineReviewPage';

function Page() {
  return <SidelineReviewPage api={sideline} sport="soccer" />;
}

export const Route = createFileRoute('/custom/sideline-review')({
  component: Page
});
